var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("base-snackbar"),
      _c(
        "v-toolbar",
        { attrs: { color: "primary", dark: "", elevation: "0", dense: "" } },
        [
          _c("span", [_vm._v("Feed Details")]),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: {
                text: "",
                color: "white",
                small: "",
                loading: _vm.priceListGetting
              },
              on: {
                click: function($event) {
                  return _vm.printPriceList()
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-file")])],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          items: _vm.stockFdDtlList,
          headers: _vm.headers,
          loading: _vm.stockFdDtlGetting,
          dense: "",
          "single-expand": ""
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c("v-file-input", {
                          attrs: {
                            accept: ".xlsx,xls",
                            label: "Update Prices",
                            "hide-details": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "append-outer",
                              fn: function() {
                                return [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        text: "",
                                        small: "",
                                        loading: _vm.uploadingFile,
                                        color: "green"
                                      },
                                      on: { click: _vm.upload }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("mdi-cloud-upload")])
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ]),
                          model: {
                            value: _vm.uploadFile,
                            callback: function($$v) {
                              _vm.uploadFile = $$v
                            },
                            expression: "uploadFile"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item, isExpanded, expand }) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "border-right" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "pa-0 ma-0",
                          attrs: { text: "", "x-small": "", color: "yellow" },
                          on: {
                            click: function($event) {
                              return _vm.editItem(item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "pa-0 ma-0",
                          attrs: {
                            text: "",
                            "x-small": "",
                            color: "red",
                            disabled: !!item.customer_forecast_types_count
                          },
                          on: {
                            click: function($event) {
                              return _vm.deleteDetail(item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-delete")])],
                        1
                      ),
                      _c("span", [
                        _vm._v(_vm._s(item.stock.description || null))
                      ])
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "border-right", attrs: { align: "right" } },
                    [_c("span", [_vm._v(_vm._s(item.size) + " kg")])]
                  ),
                  _c(
                    "td",
                    { attrs: { align: "right" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "pa-0 ma-0",
                          class: isExpanded ? "is-expanded" : "",
                          attrs: {
                            text: "",
                            "x-small": "",
                            color: "blue-grey"
                          },
                          on: {
                            click: function($event) {
                              return expand(!isExpanded)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-chevron-down")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function({ item }) {
              return [
                _c(
                  "td",
                  { attrs: { colspan: "3" } },
                  [
                    _c(
                      "v-row",
                      { staticClass: "border-bottom ma-0" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0",
                            attrs: { cols: "3", align: "center" }
                          },
                          [
                            _c("span", { staticClass: "grey--text" }, [
                              _vm._v("Cost / Bag")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0",
                            attrs: { cols: "3", align: "center" }
                          },
                          [
                            _c("span", { staticClass: "grey--text" }, [
                              _vm._v("Cost / Kilo")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0",
                            attrs: { cols: "3", align: "center" }
                          },
                          [
                            _c("span", { staticClass: "grey--text" }, [
                              _vm._v("Resell / Bag")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0",
                            attrs: { cols: "3", align: "center" }
                          },
                          [
                            _c("span", { staticClass: "grey--text" }, [
                              _vm._v("Resell / Kilo")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      { staticClass: "ma-0" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0 border-right",
                            attrs: { cols: "3", align: "right" }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$float(item.per_bag).toFixed(2))
                              )
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0 border-right",
                            attrs: { cols: "3", align: "right" }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$float(item.per_kilo).toFixed(2))
                              )
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0 border-right",
                            attrs: { cols: "3", align: "right" }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$float(item.resell_per_bag).toFixed(2)
                                )
                              )
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0",
                            attrs: { cols: "3", align: "right" }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$float(item.resell_per_kilo).toFixed(2)
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }